import { QueryClient } from '@tanstack/react-query';

// Module singleton so code above QueryClientProvider in the tree (UserStatus, which owns the
// active org) can evict the cache without a hook.
const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            refetchOnWindowFocus: false,
            retry: 0,
            staleTime: 0
        }
    }
});

export default queryClient;
